var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fe-spacing-vertical"},[_c('RatingTitle'),_c('div',[_c('div',[_c('div',{staticClass:"fe-mb-xl"},[_c('RatingSummary')],1),_c('div',[_c('RatingCta')],1)]),_c('div',[_c('MyReviewList',{staticClass:"fe-mb-m"}),_c('GalleryList',{staticClass:"fe-mb-m"}),_c('div',[_c('ReviewList')],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }